module.exports = __webpack_public_path__ + "static/img/site.996087fb.png";